<div class="review-card w-100">

  <ng-container *ngIf="review">

    <div *ngIf="small">

      <div class="review-description small-clamp">
        <p class="mb-0 mb-1">«{{ review.description }}»</p>
      </div>

      <div class=" review-header">
        <app-verification-badge [fromQuoteRequest]="review.fromQuoteRequest ?? false" [size]="16"></app-verification-badge>
        <img *ngIf="review.userFlag" [src]="Utils.getFlagSrc(review.userFlag)"
          [alt]="Utils.getFlagName(review.userFlag) + ' flag'" [title]="Utils.getFlagName(review.userFlag)"
          [attr.aria-label]="Utils.getFlagName(review.userFlag)" class="flag-small" onerror="this.style.display='none'">
        <h4 class="partner-name-small">{{ review.userName }}</h4>
      </div>
      <div class="review-footer" *ngIf="showDate">
        <span class="published-date-small">{{review.createdAt | date: 'dd/MM/yyyy':'':'en-US'}}</span>
      </div>

    </div>

    <div *ngIf="!small">
      <div class="review-header w-100 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <app-verification-badge [fromQuoteRequest]="review.fromQuoteRequest ?? false" [size]="28"></app-verification-badge>
          <div class="d-flex flex-column ">
            <h4 class="partner-name">{{ review.userName }}</h4>
            <div class="user-info" *ngIf="!small">
              <img *ngIf="review.userFlag" [src]="Utils.getFlagSrc(review.userFlag)"
                [alt]="Utils.getFlagName(review.userFlag) + ' flag'" [title]="Utils.getFlagName(review.userFlag)"
                [attr.aria-label]="Utils.getFlagName(review.userFlag)" class="flag-icon"
                onerror="this.style.display='none'">
              <span class="text-muted">{{ review.userFlag | countryName: review.nationality }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="review.rates != 0">
          <app-rating-badge [averageRate]="review.rates"></app-rating-badge>
        </div>
        
      </div>

      <div class="review-description" [class.small-clamp]="small">
        <p class="mb-0 mt-1" [class.show-full]="showFullReview">«{{ review.description }}»</p>
      </div>

      <div class="review-footer" *ngIf="showDate">
        <span class="published-date">{{review.createdAt | date: 'dd/MM/yyyy':'':'en-US'}}</span>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="!review">
    <div class="review-description">
      <p class=" mb-0">
        {{ 'This clinic has no reviews yet.' | translate }}
        <br class="d-block d-sm-none" />
      </p>
    </div>
  </ng-container>

</div>